import { TextField } from "@radix-ui/themes";
import { ChangeEvent, ReactNode } from "react";
import { UiAlert } from "../alert";

interface UiInputProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: string | number;
  value?: string | number;
  className?: string;
  label?: string;
  placeholder?: string;
  name?: string;
  errors?: string[];
  slotNode?: ReactNode;
  type?:
    | "number"
    | "search"
    | "time"
    | "text"
    | "hidden"
    | "date"
    | "datetime-local"
    | "email"
    | "month"
    | "password"
    | "tel"
    | "url"
    | "week";
}

export function UiInput({
  onChange,
  className,
  name,
  defaultValue,
  placeholder,
  label,
  errors,
  slotNode,
  value,
  type,
}: UiInputProps) {
  return (
    <div className="ui-input-container">
      {label && <label className="ui-form-label">{label}</label>}
      <TextField.Root
        className={`${className}`}
        name={name}
        placeholder={placeholder}
        size="3"
        {...(value !== undefined ? { value } : { defaultValue })}
        onChange={onChange}
        type={type}
      >
        {slotNode && <TextField.Slot>{slotNode}</TextField.Slot>}
      </TextField.Root>
      {errors?.length ? (
        <UiAlert>
          {errors.map((error, index) => (
            <p key={`${error}-${index}`}>{error}</p>
          ))}
        </UiAlert>
      ) : null}
    </div>
  );
}
